<template>
  <div class="exam-search-result">
    <div
      v-if="items.length > 0"
      class="exam-search-result__wrapper"
    >
      <router-link
        v-for="(item) in items"
        :key="item.id"
        class="exam-search-result__item"
        :to="link(item)"
      >
        <div class="exam-search-result__code">
          {{ item.mnemonic }}
        </div>
        <div class="exam-search-result__description">
          <div class="exam-search-result__name">
            {{ item.name }}
          </div>
          <div
            v-if="item.synonym"
            class="exam-search-result__synonym"
          >
            Sinônimos: {{ item.synonym }}
          </div>
          <div
            v-else
            class="exam-search-result__synonym"
          >
            Sem sinônimos
          </div>
        </div>
      </router-link>
    </div>
    <div
      v-if="!loading && items.length === 0"
      class="exam-search-result__no-results"
    >
      <img
        src="/static/images/site/no-results.svg"
        alt="sem resultados"
      >
      <div class="exam-search-result__no-results-text">
        Nenhum exame foi encontrado :(
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExamSearchResult',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    link (item) {
      return {
        path: 'detalhes',
        query: {
          mnemonic: item.mnemonic
        }
      }
    }
  }
}
</script>

<style lang="scss">
.exam-search-result {
  padding: 0 0 25px;

  &__no-results {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    padding: 60px 0;

    &-text {
      font-size: 18px;
      color: #303030;
      font-weight: 500;
      width: 100%;
      text-align: center;
      padding: 20px 0;
    }
  }
  &__code {
    background-color: #B0234B;
    color: #fff;
    font-size: 12px;
    text-transform: uppercase;
    width: 82px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    border-radius: 4px;
    margin-right: 14px;
  }
  &__name {
    color: #7F1A54;
    font-size: 16px;
    font-weight: 600;
    width: 100%;
  }
  &__synonym {
    font-size: 14px;
    color: #7A7A7A;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }
  &__item {
    text-decoration: none !important;
    background-color: #fff;
    cursor: pointer;
    display: flex;
    margin-bottom: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
    padding: 8px;
    border-radius: 5px;
  }
  &__description {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: calc(100% - 96px);
  }
}
</style>
